import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-16 px-4 bg-brand-warm scroll-mt-10" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-207">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-text-main mb-4" data-id="element-208">
            SCEGLI IL TUO PERCORSO
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start" data-id="element-209">
          {/* COMPLETO CARD */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-brand-olive rounded-3xl p-6 sm:p-8 shadow-lg relative" data-id="element-210">
            <h3 className="text-xl font-bold text-brand-text-main mb-2" data-id="element-211">
              📦 PACCHETTO COMPLETO
            </h3>
            <p className="text-sm text-brand-text-muted mb-6" data-id="element-212">
              Tutto quello che ti serve per iniziare e trasformare la tua
              alimentazione.
            </p>

            <div className="space-y-3 mb-8" data-id="element-213">
              {['Tomo 1 — Fondamenti del Benessere Mediterraneo', 'Tomo 2 — Ricette Veloci Quotidiane', 'Tomo 3 — Ricette Proteiche Mediterranee', 'Tomo 4 — Meal Prep Mediterraneo', 'Tomo 5 — Ricette Senza Zucchero e Senza Glutine', 'Tomo 6 — Estate Mediterranea', 'BONUS 1 — Piano Alimentare Mediterraneo 30 Giorni (Valore €27)', 'BONUS 2 — Lista della Spesa Mediterranea Premium (Valore €17)', 'BONUS 3 — Guida Snack & Dessert Healthy (Valore €27)', 'BONUS 4 — Guida Anti-Gonfiore Mediterranea (Valore €27)', 'Accesso digitale immediato e permanente'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-214">
                  <CheckIcon className="w-5 h-5 text-brand-olive shrink-0 mt-0.5" data-id="element-215" />
                  <span className="text-sm text-brand-text-main font-medium" data-id="element-216">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="flex justify-between items-center border-t border-gray-100 pt-4 mb-6" data-id="element-217">
              <div data-id="element-218">
                <span className="text-xs text-brand-text-muted uppercase font-bold block" data-id="element-219">
                  Valore Reale
                </span>
                <span className="text-lg text-gray-400 line-through" data-id="element-220">€195</span>
              </div>
              <div className="text-right" data-id="element-221">
                <span className="text-xs text-brand-olive uppercase font-bold block" data-id="element-222">
                  Oggi
                </span>
                <span className="text-3xl font-bold text-brand-text-main" data-id="element-223">
                  €19,90
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44759694901383:1" variant="primary" className="w-full mb-4" data-id="element-224">
              🚀 SÌ, VOGLIO IL PACCHETTO COMPLETO
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] text-brand-text-muted font-medium" data-id="element-225">
              <span className="flex items-center gap-1" data-id="element-226">
                <ZapIcon className="w-3 h-3" data-id="element-227" /> Accesso Immediato
              </span>
              <span data-id="element-228">•</span>
              <span className="flex items-center gap-1" data-id="element-229">
                <ShieldCheckIcon className="w-3 h-3" data-id="element-230" /> Garanzia 7 Giorni
              </span>
              <span data-id="element-231">•</span>
              <span className="flex items-center gap-1" data-id="element-232">
                <CreditCardIcon className="w-3 h-3" data-id="element-233" /> Pagamento Unico
              </span>
            </div>
          </motion.div>

          {/* PREMIUM RESET CARD */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-olive-dark text-white rounded-3xl p-6 sm:p-8 shadow-2xl relative border border-brand-gold/30 transform md:-translate-y-4" data-id="element-234">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-235">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-236" />
              La scelta più consigliata
            </div>

            <h3 className="text-xl font-bold text-brand-gold mb-2 mt-2" data-id="element-237">
              ⭐ SISTEMA PREMIUM RESET
            </h3>
            <p className="text-sm text-gray-200 mb-6" data-id="element-238">
              Per chi vuole una trasformazione completa e definitiva.
            </p>

            <div className="space-y-4 mb-8" data-id="element-239">
              <div className="flex items-start gap-2" data-id="element-240">
                <CheckIcon className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-241" />
                <span className="text-sm font-medium" data-id="element-242">
                  Tutto il Pacchetto Completo (6 Tomi + 4 Bonus)
                </span>
              </div>
              <div className="flex items-start gap-2 bg-white/10 p-3 rounded-xl border border-white/10" data-id="element-243">
                <CheckIcon className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-244" />
                <div data-id="element-245">
                  <span className="text-sm font-bold text-brand-gold block mb-1" data-id="element-246">
                    METODO RESET 21 GIORNI
                  </span>
                  <span className="text-xs text-gray-200" data-id="element-247">
                    Il programma esclusivo per resettare completamente le tue
                    abitudini in tre settimane.
                  </span>
                </div>
              </div>

              <div className="bg-black/20 p-4 rounded-xl mt-4" data-id="element-248">
                <p className="text-xs font-bold text-brand-gold mb-3 uppercase tracking-wider" data-id="element-249">
                  🔥 Come funziona:
                </p>
                <ul className="space-y-3 text-xs text-gray-200" data-id="element-250">
                  <li data-id="element-251">
                    <strong className="text-white" data-id="element-252">
                      Settimana 1 — Organizza:
                    </strong>{' '}
                    Riorganizza la cucina e imposta la tua base mediterranea.
                  </li>
                  <li data-id="element-253">
                    <strong className="text-white" data-id="element-254">
                      Settimana 2 — Attiva:
                    </strong>{' '}
                    Inizia il piano, sperimenta le ricette, scopri cosa funziona
                    per il tuo corpo.
                  </li>
                  <li data-id="element-255">
                    <strong className="text-white" data-id="element-256">
                      Settimana 3 — Consolida:
                    </strong>{' '}
                    Trasforma le nuove abitudini in routine automatiche che
                    durano nel tempo.
                  </li>
                </ul>
              </div>
            </div>

            <div className="space-y-2 mb-6 border-t border-white/10 pt-4" data-id="element-257">
              <div className="flex justify-between text-xs text-gray-300" data-id="element-258">
                <span data-id="element-259">6 Tomi Metodo Mediterraneo™</span>
                <span data-id="element-260">€97</span>
              </div>
              <div className="flex justify-between text-xs text-gray-300" data-id="element-261">
                <span data-id="element-262">4 Bonus Esclusivi</span>
                <span data-id="element-263">€98</span>
              </div>
              <div className="flex justify-between text-xs text-brand-gold font-bold" data-id="element-264">
                <span data-id="element-265">Metodo Reset 21 Giorni</span>
                <span data-id="element-266">€97</span>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-white/20 pt-4 mb-2" data-id="element-267">
              <div data-id="element-268">
                <span className="text-xs text-gray-300 uppercase font-bold block" data-id="element-269">
                  Valore Reale
                </span>
                <span className="text-lg text-gray-400 line-through" data-id="element-270">€292</span>
              </div>
              <div className="text-right" data-id="element-271">
                <span className="text-xs text-brand-gold uppercase font-bold block" data-id="element-272">
                  Oggi
                </span>
                <span className="text-4xl font-bold text-white" data-id="element-273">€27,90</span>
              </div>
            </div>

            <p className="text-center text-xs text-brand-gold mb-6 italic" data-id="element-274">
              Per meno del costo di una cena fuori — un sistema che userai per
              anni.
            </p>

            <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full mb-4" data-id="element-275">
              🚀 SÌ, VOGLIO IL SISTEMA PREMIUM
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] text-gray-300 font-medium" data-id="element-276">
              <span className="flex items-center gap-1" data-id="element-277">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-278" /> Accesso
                Immediato
              </span>
              <span data-id="element-279">•</span>
              <span className="flex items-center gap-1" data-id="element-280">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-281" /> Garanzia
                7 Giorni
              </span>
              <span data-id="element-282">•</span>
              <span className="flex items-center gap-1" data-id="element-283">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-284" /> Pagamento
                Unico
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}